module.exports = __webpack_public_path__ + "img/Yanlei_Diao-500x500.9152f3b0.jpg";